import { EntityList, EntityListProps } from 'components/EntityList'
import { User } from 'gql.generated'
import { Box } from 'grid'
import {
  ConstrainMode,
  DirectionalHint,
  ITooltipProps,
  PrimaryButton,
  SelectionMode,
  TooltipDelay,
  TooltipHost,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

export type SynergyListProps = EntityListProps<ReadProvings_workers>

export const SynergyList: React.FunctionComponent<SynergyListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('relevance', {
        onRender: (item, i, col) => {
          const content = item.matches.map((m: any) => <li key={m}>{m}</li>)
          const tooltipProps: ITooltipProps = {
            onRenderContent: () => (
              <ul style={{ margin: 10, padding: 0 }}>{content}</ul>
            ),
          }
          return (
            <Box>
              <TooltipHost
                styles={{ root: { display: 'inline-block' } }}
                directionalHint={DirectionalHint.bottomCenter}
                delay={TooltipDelay.zero}
                tooltipProps={tooltipProps}
              >
                {item.relevance}
              </TooltipHost>
            </Box>
          )
        },
      }),
      fieldColumn('id', { ungroupable: true }),
      fieldColumn('title', { ungroupable: true }),
      fieldColumn('provingGround.title', {
        onRender: (item, i, col) => {
          return `${item.provingGround!.title}, ${
            item.provingGround!.countryCode
          }`
        },
      }),
      fieldColumn('responsible', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.responsible.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    {user.name}{' '}
                  </Box>
                )
              })}
            </div>
          )
        },
        ungroupable: true,
        minWidth: 105,
      }),
      fieldColumn('department', { ungroupable: true }),
      fieldColumn('matches', {
        onRender: (item, i, col) => {
          const content = item.matches.map((m: any) => <li key={m}>{m}</li>)
          return (
            <Box>
              <ul>{content}</ul>
            </Box>
          )
        },
        ungroupable: true,
        minWidth: 200,
      }),
      fieldColumn('contact', {
        onRender: (item, i, col) => {
          return (
            <div key={i}>
              {item.responsible.map((user: User, a: any) => {
                return (
                  <Box key={a} style={{ whiteSpace: 'pre-line' }}>
                    <PrimaryButton
                      href={`mailto:${user.email}?subject=${item.id}`}
                    >
                      Kontaktaufnahme
                    </PrimaryButton>
                  </Box>
                )
              })}
            </div>
          )
        },
        ungroupable: true,
        minWidth: 105,
      }),
    ],
    [fieldColumn]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.none}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
      disableMarquee={true}
    />
  )
}
